import { Suspense, lazy } from 'react';

// Project imports
import Loader from './Loader';

// Функція для штучної затримки
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Оновлена функція Loadable
const Loadable = (importFunc, showLoader = true, delayMs = 0) => {
    const LazyComponent = lazy(async () => {
        await delay(delayMs);                   // Додаємо затримку
        return importFunc();                    // Імпортуємо компонент після затримки
    });

    return (props) => (
         
        <Suspense fallback={showLoader && (<Loader />)}> 
            <LazyComponent {...props} />
        </Suspense>
    );
};

export default Loadable;
